const BOT_UA_REGEX: RegExp =
    /Lighthouse|HeadlessChrome|PageSpeed|Googlebot|bingbot|YandexBot|Baiduspider|DuckDuckBot|AhrefsBot|SemrushBot/i;

/**
 * Replicates the anti-bot filter previously inlined in index.html loaders.
 *
 * Returns `true` when the current runtime looks like an automated agent
 * (Lighthouse, HeadlessChrome, search crawlers, SEO bots, WebDriver).
 * Consumers of ScriptLoaderService use this to skip loading of analytics
 * trackers — bots pollute metrics and their data is not actionable.
 */
export function isLikelyBot(windowRef: Window): boolean {
    const nav: Navigator | undefined = (windowRef as { navigator?: Navigator }).navigator;
    if (!nav) {
        return false;
    }
    if (nav.webdriver) {
        return true;
    }
    const ua: string = nav.userAgent;
    return BOT_UA_REGEX.test(ua);
}
